import { getPlanLabel } from '../../../common/plan-label'

const COMPACT_BASIC_PLUS_PLAN = [{
  title: 'Core writing tools without limitation',
  enabled: true
}, {
  title: 'Basic pre production tools',
  enabled: true
}, {
  title: 'Unlimited AI requests and images',
  enabled: true
}, {
  title: '100 🔄 Monthly credits for AI Videos',
  enabled: true
}]

const COMPACT_FREE_PLAN = [
  {
    title: 'Basic Writing Tools',
    enabled: true
  },
  {
    title: 'Limited access to story development features',
    enabled: true
  },
  {
    title: 'AI Requests with a 30-day usage period',
    enabled: true
  },
  {
    title: '15 one time credits for AI Videos',
    enabled: true
  }
]

const COMPACT_PRO_PLAN = [{
  title: 'Unlimited AI film budgeting',
  enabled: true
}, {
  title: 'Automated pre production suite',
  enabled: true
}, {
  title: 'Premium quality images',
  enabled: true
}, {
  title: '210 🔄 Monthly credits for AI Videos',
  enabled: true
}]

const PLANS = [{
  title: getPlanLabel('free', { full: true }).label,
  id: 'free',
  descriptions: 'Get started with our free plan and enjoy essential features without any cost.',
  prices: {
    monthly: {
      price: 0,
      discount: 0
    },
    '3month': {
      price: 0,
      discount: 0
    },
    yearly: {
      price: 0,
      discount: 0
    }
  },
  items: COMPACT_FREE_PLAN
}, {
  title: 'Creator',
  id: 'basicPlus',
  descriptions: 'Enhance productivity with unlimited access to essential writing tools.',
  prices: {
    monthly: {
      price: '40',
      discount: 0
    },
    '3month': {
      price: '108',
      oldPrice: '120',
      discount: 10
    },
    yearly: {
      price: '336',
      oldPrice: '480',
      discount: 30
    }
  },
  items: [...COMPACT_BASIC_PLUS_PLAN],
  level: 2
}, {
  title: 'Pro',
  id: 'pro',
  descriptions: 'Amplify your process efficiency with full pre-production automated suite',
  prices: {
    monthly: {
      price: '100',
      discount: 0
    },
    '3month': {
      price: '270',
      oldPrice: '300',
      discount: 10
    },
    yearly: {
      price: '840',
      oldPrice: '1200',
      discount: 30
    }
  },
  items: COMPACT_PRO_PLAN,
  level: 3
}
//   {
//   title: 'Enterprise',
//   id: 'enterprise',
//   descriptions: 'All features unlimited in Pro plan and custom solutions'
// }
]

const PRICE_TABS = [
  { id: 'monthly', title: 'Monthly' },
  {
    id: '3month',
    title: 'Every 3 months',
    discount: {
      text: '(save 10%)',
      color: 'rgb(218, 136, 19)',
      style: {
        transform: 'translate(0, -50%)'
      }
    }
  },
  {
    id: 'yearly',
    title: 'Annually',
    discount: {
      text: '(save 30%)',
      color: '#649C07'
    }
  }
]

export {
  PLANS,
  PRICE_TABS
}
